import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Room } from '@tanzspass/shared';
import { School } from '@tanzspass/shared';
import { RoomService } from '../../services/room.service';
import { TvScreenService } from '../../services/tv-screen.service';
import { InfosystemEventsComponent } from '../infosystem-events/infosystem-events.component';
import { InfosystemFeaturedCoursesComponent } from '../infosystem-featured-courses/infosystem-featured-courses.component';
import { InfosystemGalleryComponent } from '../infosystem-gallery/infosystem-gallery.component';
import { InfosystemHvvComponent } from '../infosystem-hvv/infosystem-hvv.component';
import { InfosystemRssComponent } from '../infosystem-rss/infosystem-rss.component';
import { InfosystemToolbarComponent } from '../infosystem-toolbar/infosystem-toolbar.component';
import { InfosystemUpcommingCoursesComponent } from '../infosystem-upcomming-courses/infosystem-upcomming-courses.component';
import { InfosystemWeatherComponent } from '../infosystem-weather/infosystem-weather.component';
dayjs.locale('de');

dayjs.extend(relativeTime);

export const SLIDE_DURATION = 15;

@Component({
  selector: 'ts-infosystem-index',
  templateUrl: './infosystem-index.component.html',
  styleUrls: ['./infosystem-index.component.scss'],
  // The TV screen is a long-running kiosk view whose content is fetched
  // asynchronously (RSS, gallery, weather, …). Hydrating it caused server- and
  // client-rendered DOM to diverge and duplicate (e.g. the RSS card rendering
  // twice). It gains nothing from SSR/hydration, so skip it for the whole subtree.
  host: { ngSkipHydration: 'true' },
  imports: [
    NgIf,
    InfosystemToolbarComponent,
    InfosystemUpcommingCoursesComponent,
    InfosystemGalleryComponent,
    InfosystemEventsComponent,
    InfosystemHvvComponent,
    InfosystemWeatherComponent,
    InfosystemRssComponent,
    InfosystemFeaturedCoursesComponent,
    NgClass,
    NgFor,
  ],
})
export class InfosystemIndexComponent implements OnInit {
  school: School = new School();

  room: Room | null = null;
  rooms: Room[] = [];
  /** True once a roomId is in the URL — picks kiosk mode over the room picker. */
  hasRoomId = false;

  constructor(
    private route: ActivatedRoute,
    private roomSrv: RoomService,
    private tvScreenSrv: TvScreenService,
    private destroyRef: DestroyRef,
  ) {
    // The kiosk's own room + school are resolved server-side and arrive with the
    // shared poll. `room` stays null until the first payload, so kiosk content
    // only paints once data exists — the picker is gated on hasRoomId, not room,
    // so it never flashes while loading.
    this.tvScreenSrv.payload$.pipe(takeUntilDestroyed()).subscribe((payload) => {
      if (payload) {
        this.room = payload.room;
        this.school = payload.school;
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const roomId = params['roomId'];

      if (roomId) {
        this.hasRoomId = true;
        // One shared poll resolves the room and feeds every panel (see TvScreenService).
        this.tvScreenSrv.start(roomId);
      } else {
        this.roomSrv.findAll().subscribe((rooms) => {
          this.rooms = rooms;
        });
      }
    });
  }
}
